import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const nearbySchema = {
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  '@id': `${SITE_URL}/nearby`,
  url: `${SITE_URL}/nearby`,
  name: '주변안내 | 영빈호텔',
  description: '영빈호텔 주변 관광명소 안내. 동대문, 남산타워, 명동, 남대문 등 서울 주요 관광지가 인근에 위치합니다.',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      item: {
        '@type': 'TouristAttraction',
        name: '동대문 (Dongdaemun)',
        description: '과거와 현재가 공존하는 대표 관광쇼핑 타운. DDM패션 타운 동대문의 저가 의류상가.',
        address: { '@type': 'PostalAddress', addressLocality: '동대문구', addressRegion: '서울특별시', addressCountry: 'KR' },
      },
    },
    {
      '@type': 'ListItem',
      position: 2,
      item: {
        '@type': 'TouristAttraction',
        name: '남산타워 (N Seoul Tower)',
        description: '서울특별시를 대표하는 랜드마크. 서울 야경을 한눈에 볼 수 있는 아름다운 곳.',
        address: { '@type': 'PostalAddress', addressLocality: '용산구', addressRegion: '서울특별시', addressCountry: 'KR' },
      },
    },
    {
      '@type': 'ListItem',
      position: 3,
      item: {
        '@type': 'TouristAttraction',
        name: '명동 (Myeongdong)',
        description: '색다른 먹거리와 쇼핑 거리가 가득한 명동. 쇼핑몰과 서점, 시내 면세점 등.',
        address: { '@type': 'PostalAddress', addressLocality: '중구', addressRegion: '서울특별시', addressCountry: 'KR' },
      },
    },
    {
      '@type': 'ListItem',
      position: 4,
      item: {
        '@type': 'TouristAttraction',
        name: '남대문 (Namdaemun)',
        description: '국보 1호 숭례문. 조선에서 가장 큰 문으로 서울의 자부심.',
        address: { '@type': 'PostalAddress', addressLocality: '중구', addressRegion: '서울특별시', addressCountry: 'KR' },
      },
    },
  ],
};

const attractions = [
  {
    id: 'dongdaemun',
    name: '동대문',
    nameEn: 'Dongdaemun',
    desc: '과거와 현재가 공존하는 대표 관광쇼핑 타운입니다. DDM패션 타운 동대문의 저가 의류상가는 가장 많은 외국인들이 찾고 시랑하는 곳입니다.',
    distance: '도보 3분',
    distanceIcon: 'ri-walk-line',
    images: [
      {
        src: 'http://www.youngbinhotel.com/thum_img/nbkorea/option/7c3241c256e59bf32fa3fbcf83fabecd_water__c1_w1000_h700.jpg',
        fallback: 'https://public.readdy.ai/ai/img_res/cc9ce6efa3cc85e1bdabdcaab480e419.jpg',
      },
      {
        src: 'http://www.youngbinhotel.com/thum_img/nbkorea/option/ddm2_water__c1_w1000_h700.jpg',
        fallback: 'https://static.readdy.ai/image/8cbc9a1dc4b359b2d65998faa584ac95/bf0f239497f94dae2f1030d42655aa07.jpeg',
      },
      {
        src: 'http://www.youngbinhotel.com/thum_img/nbkorea/option/ddm3_water__c1_w1000_h700.jpg',
        fallback: 'https://readdy.ai/api/search-image?query=Dongdaemun%20fashion%20market%20shopping%20district%20Seoul%20night%20busy%20street%20colorful%20shop%20signs%20crowds%20vibrant%20nightlife%20Korean%20street%20market%20atmosphere&width=600&height=400&seq=fb-ddm-3&orientation=landscape',
      },
      {
        src: 'http://www.youngbinhotel.com/thum_img/nbkorea/option/ddm4_water__c1_w1000_h700.jpg',
        fallback: 'https://readdy.ai/api/search-image?query=Dongdaemun%20History%20Culture%20Park%20Seoul%20outdoor%20plaza%20modern%20architecture%20daytime%20tourists%20walking%20urban%20park%20traditional%20elements%20clean%20wide%20shot&width=600&height=400&seq=fb-ddm-4&orientation=landscape',
      },
    ],
  },
  {
    id: 'namsan',
    name: '남산타워',
    nameEn: 'N Seoul Tower',
    desc: '서울특별시를 대표하는 명실상부한 랜드마크 중 하나로 서울 야경을 한눈에 볼 수 있는 아름다운 곳입니다.',
    distance: '차량 15분',
    distanceIcon: 'ri-car-line',
    images: [
      {
        src: 'http://www.youngbinhotel.com/thum_img/nbkorea/option/namsan1_water__c1_w1000_h700.jpg',
        fallback: 'https://readdy.ai/api/search-image?query=N%20Seoul%20Tower%20Namsan%20illuminated%20night%20colorful%20lights%20Seoul%20city%20skyline%20panoramic%20romantic%20atmosphere%20long%20exposure%20dark%20sky%20warm%20glow&width=600&height=400&seq=fb-namsan-1&orientation=landscape',
      },
      {
        src: 'http://www.youngbinhotel.com/thum_img/nbkorea/option/namsan2_water__c1_w1000_h700.jpg',
        fallback: 'https://readdy.ai/api/search-image?query=N%20Seoul%20Tower%20daytime%20Namsan%20mountain%20blue%20sky%20green%20trees%20iconic%20red%20white%20tower%20structure%20Seoul%20Korea%20landmark%20clear%20weather&width=600&height=400&seq=fb-namsan-2&orientation=landscape',
      },
      {
        src: 'http://www.youngbinhotel.com/thum_img/nbkorea/option/namsan3_water__c1_w1000_h700.jpg',
        fallback: 'https://readdy.ai/api/search-image?query=Seoul%20city%20panoramic%20aerial%20view%20Namsan%20Tower%20observation%20deck%20dusk%20golden%20hour%20city%20lights%20Han%20River%20visible%20distance%20beautiful%20skyline&width=600&height=400&seq=fb-namsan-3&orientation=landscape',
      },
      {
        src: 'http://www.youngbinhotel.com/thum_img/nbkorea/option/namsan4_water__c1_w1000_h700.jpg',
        fallback: 'https://readdy.ai/api/search-image?query=Namsan%20Tower%20love%20locks%20fence%20colorful%20padlocks%20romantic%20tourist%20attraction%20Seoul%20Korea%20bokeh%20background%20tower%20visible%20couple&width=600&height=400&seq=fb-namsan-4&orientation=landscape',
      },
    ],
  },
  {
    id: 'myeongdong',
    name: '명동',
    nameEn: 'Myeongdong',
    desc: '서울특별시 중구에 있는 동, 서울특별시 중구에 속한 동입니다. 중구로 · 을지로 · 남대문로 사이에 있습니다. 색다른 먹거리와 쇼핑 거리가 가득한 명동, 쇼핑몰과 서점, 시내 면세점 등이 있는 쇼핑을 즐기기 가장 좋은 곳입니다.',
    distance: '지하철 10분',
    distanceIcon: 'ri-subway-line',
    images: [
      {
        src: 'http://www.youngbinhotel.com/thum_img/nbkorea/option/myeong1_water__c1_w1000_h700.jpg',
        fallback: 'https://static.readdy.ai/image/8cbc9a1dc4b359b2d65998faa584ac95/d850a9272afc9ff0fbe74289b0bb33f9.jpeg',
      },
      {
        src: 'http://www.youngbinhotel.com/thum_img/nbkorea/option/myeong2_water__c1_w1000_h700.jpg',
        fallback: 'https://readdy.ai/api/search-image?query=Myeongdong%20Cathedral%20Seoul%20Gothic%20architecture%20historic%20Catholic%20church%20daytime%20blue%20sky%20surrounded%20modern%20city%20buildings%20landmark%20Korea&width=600&height=400&seq=fb-myeong-2&orientation=landscape',
      },
      {
        src: 'http://www.youngbinhotel.com/thum_img/nbkorea/option/myeong3_water__c1_w1000_h700.jpg',
        fallback: 'https://readdy.ai/api/search-image?query=Myeongdong%20street%20food%20market%20Seoul%20Korean%20food%20stalls%20tteokbokki%20hotteok%20tourists%20eating%20colorful%20food%20carts%20lively%20atmosphere%20evening&width=600&height=400&seq=fb-myeong-3&orientation=landscape',
      },
      {
        src: 'http://www.youngbinhotel.com/thum_img/nbkorea/option/myeong4_water__c1_w1000_h700.jpg',
        fallback: 'https://readdy.ai/api/search-image?query=Myeongdong%20luxury%20shopping%20district%20Seoul%20cosmetics%20stores%20fashion%20boutiques%20busy%20daytime%20street%20international%20tourists%20shopping%20modern%20urban%20Korea&width=600&height=400&seq=fb-myeong-4&orientation=landscape',
      },
    ],
  },
  {
    id: 'namdaemun',
    name: '남대문',
    nameEn: 'Namdaemun',
    desc: '서울의 힘로, 국보 1호 숭례문 입니다. 행복한 여행의 낭만이자 정문으로 역동을 확인 문으로 한양 성곽과 함께 1396년에 만들어졌습니다. 조선에서 가장 큰 문으로 서울의 자부심 입니다.',
    distance: '지하철 15분',
    distanceIcon: 'ri-subway-line',
    images: [
      {
        src: 'http://www.youngbinhotel.com/thum_img/nbkorea/option/namdae1_water__c1_w1000_h700.jpg',
        fallback: 'https://readdy.ai/api/search-image?query=Namdaemun%20Sungnyemun%20Gate%20Seoul%20national%20treasure%20illuminated%20night%20traditional%20Korean%20architecture%20curved%20tiled%20roof%20golden%20lighting%20historic%20landmark%20dark%20background&width=600&height=400&seq=fb-namdae-1&orientation=landscape',
      },
      {
        src: 'http://www.youngbinhotel.com/thum_img/nbkorea/option/namdae2_water__c1_w1000_h700.jpg',
        fallback: 'https://readdy.ai/api/search-image?query=Namdaemun%20traditional%20gate%20Seoul%20daytime%20blue%20sky%20historic%20stone%20fortress%20gate%20Joseon%20dynasty%20architecture%20surrounded%20modern%20city%20wide%20angle&width=600&height=400&seq=fb-namdae-2&orientation=landscape',
      },
      {
        src: 'http://www.youngbinhotel.com/thum_img/nbkorea/option/namdae3_water__c1_w1000_h700.jpg',
        fallback: 'https://readdy.ai/api/search-image?query=Namdaemun%20market%20Seoul%20traditional%20Korean%20market%20busy%20vendors%20fresh%20produce%20street%20food%20traditional%20goods%20lively%20atmosphere%20daytime%20colorful&width=600&height=400&seq=fb-namdae-3&orientation=landscape',
      },
      {
        src: 'http://www.youngbinhotel.com/thum_img/nbkorea/option/namdae4_water__c1_w1000_h700.jpg',
        fallback: 'https://readdy.ai/api/search-image?query=Namdaemun%20market%20Seoul%20seafood%20food%20stalls%20colorful%20fresh%20ingredients%20traditional%20Korean%20market%20vendors%20authentic%20local%20food%20scene%20vibrant&width=600&height=400&seq=fb-namdae-4&orientation=landscape',
      },
    ],
  },
];

interface FallbackImgProps {
  src: string;
  fallback: string;
  alt: string;
  className?: string;
}

const FallbackImg = ({ src, fallback, alt, className }: FallbackImgProps) => {
  const [imgSrc, setImgSrc] = useState(src);
  return (
    <img
      src={imgSrc}
      alt={alt}
      className={className}
      onError={() => setImgSrc(fallback)}
    />
  );
};

const NearbyPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = '주변안내 | 영빈호텔 YOUNGBIN HOTEL';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', '영빈호텔 주변 관광명소 안내. 동대문, 남산타워, 명동, 남대문 등 서울 주요 관광지가 인근에 위치합니다.');
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-nearby';
    script.textContent = JSON.stringify(nearbySchema);
    document.head.appendChild(script);
    return () => {
      document.title = '영빈호텔 | YOUNGBIN HOTEL';
      if (metaDesc) metaDesc.setAttribute('content', '서울 중구 동대문 영빈호텔. 동대문 쇼핑상가 도보 10분, 사우나·무료와이파이·24시간 컨시어지 제공. TEL: 02-2277-1141');
      const el = document.getElementById('schema-nearby');
      if (el) el.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Sub Header */}
      <div className="pt-20 bg-stone-800">
        <div className="max-w-7xl mx-auto px-6 py-10">
          <p className="text-amber-400 text-xs tracking-[0.3em] uppercase mb-2">NEARBY ATTRACTIONS</p>
          <h1 className="text-3xl font-bold text-white" style={{ fontFamily: "'Playfair Display', serif" }}>
            주변안내
          </h1>
        </div>
        {/* Sub Nav */}
        <div className="border-t border-white/10">
          <div className="max-w-7xl mx-auto px-6">
            <div className="flex gap-0 overflow-x-auto">
              {attractions.map((a) => (
                <a
                  key={a.id}
                  href={`#${a.id}`}
                  className="px-6 py-4 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer border-b-2 border-transparent text-white/60 hover:text-white hover:border-white/40"
                >
                  {a.name}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Attractions */}
      <div className="max-w-5xl mx-auto px-6 py-16 flex flex-col gap-20">
        {attractions.map((attraction) => (
          <section key={attraction.id} id={attraction.id}>
            {/* 제목 */}
            <div className="flex items-end gap-2 mb-3 flex-wrap">
              <h2
                className="text-xl md:text-2xl font-bold text-gray-900 whitespace-nowrap"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                {attraction.name}
              </h2>
              <span className="text-xs md:text-sm text-stone-400 font-light mb-0.5 whitespace-nowrap">{attraction.nameEn}</span>
              <span className="ml-auto flex items-center gap-1.5 text-xs text-amber-700 font-medium bg-amber-50 px-3 py-1 rounded-full whitespace-nowrap">
                <div className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className={attraction.distanceIcon} />
                </div>
                {attraction.distance}
              </span>
            </div>
            <div className="w-12 h-0.5 bg-amber-500 mb-4" />
            <p className="text-sm text-gray-600 leading-relaxed mb-7 max-w-2xl">{attraction.desc}</p>

            {/* 이미지 레이아웃 - 메인 사진 위에 크게, 아래 3장 가로 배치 */}
            <div className="flex flex-col gap-3">
              {/* 메인 사진 */}
              <div className="w-full h-72 md:h-96 overflow-hidden rounded-xl">
                <FallbackImg
                  src={attraction.images[0].src}
                  fallback={attraction.images[0].fallback}
                  alt={`${attraction.name} 1`}
                  className="w-full h-full object-cover object-center hover:scale-105 transition-transform duration-500"
                />
              </div>
              {/* 하단 2장 */}
              <div className="grid grid-cols-2 gap-3">
                {attraction.images.slice(1, 3).map((img, i) => (
                  <div key={i} className="h-44 md:h-52 overflow-hidden rounded-xl">
                    <FallbackImg
                      src={img.src}
                      fallback={img.fallback}
                      alt={`${attraction.name} ${i + 2}`}
                      className="w-full h-full object-cover object-center hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                ))}
              </div>
            </div>
          </section>
        ))}

        {/* Back */}
        <div className="text-center pt-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-8 py-3 border border-stone-300 text-gray-700 rounded-full text-sm hover:bg-stone-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-left-line" />
            </div>
            메인으로 돌아가기
          </Link>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default NearbyPage;
